import "./rdfLibFactory";

import base from "./panes/base";
import DataGrid from "./panes/DataGrid";
import Directory from "./panes/Directory";

export { base };

export default [
  base,
  DataGrid,
  Directory,
];
